import type { Corral, Pasture, Retreat } from "shared/types";
import {
  type PastureDispatchAction,
  LIST_FARM_CORRALS,
  LIST_FARM_PASTURES,
  LIST_FARM_RETREATS,
} from "../actions/pastureActions";

export type PastureState = {
  farmCorrals: Corral[];
  farmPastures: Pasture[];
  farmRetreats: Retreat[];
};

export const initialState: PastureState = {
  farmCorrals: [],
  farmPastures: [],
  farmRetreats: [],
};

export default function pastureReducer(
  state: PastureState = initialState,
  action: PastureDispatchAction
): PastureState {
  if (action.type === LIST_FARM_CORRALS) {
    return {
      ...state,
      farmCorrals: action.payload.corrals,
    };
  }

  if (action.type === LIST_FARM_PASTURES) {
    return {
      ...state,
      farmPastures: action.payload.pastures,
    };
  }

  if (action.type === LIST_FARM_RETREATS) {
    return {
      ...state,
      farmRetreats: action.payload.retreats,
    };
  }

  return { ...state };
}
